<template>
  <v-reports
    v-if="access.report_sale_by_item"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    salesByItem
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  >
    <template #top>
      <v-flex class="px-2 mt-2" md4 xs4>
        <v-combobox
          v-model="supplier"
          v-bind:items="all_suppliers"
          item-text="supplier_name"
          solo
          dense
          prepend-inner-icon="mdi-account"
        />
      </v-flex>
    </template>
    <template #search_text>
      <v-btn icon @click="downloadResult">
        <v-icon> mdi-download </v-icon>
      </v-btn>
      <v-dialog v-model="proccesDialog" max-width="400px">
        <v-card>
          <v-list-item-action style="width: 338px; padding-left: 40px">
            <v-progress-linear
              :color="excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'"
              background-color="white"
              height="10"
              style="border: 1px solid rgba(0, 0, 0, 0.26)"
              v-bind:value="excel_dowload_proccess"
              striped
            />
            <v-list-item-action-text
              >{{ $t("download") }}
              {{ excel_dowload_proccess.toFixed() + " %" }}
            </v-list-item-action-text>
          </v-list-item-action>
        </v-card>
      </v-dialog>
      <v-slide-x-reverse-transition>
        <v-btn icon @click="searchActivate">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <v-slide-x-reverse-transition>
        <v-text-field
          v-model="search"
          ref="search_field"
          v-if="search_text"
          :autofocus="search_field"
          class="mt-3 pa-0"
          append-icon="mdi-close"
          @click:append="
            {
              (search_text = false), (search = ''), update(params);
            }
          "
          @change="
            {
              (page = 1), update(params);
            }
          "
          label="Search"
        />
      </v-slide-x-reverse-transition>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
import Currency from "../../mixins/settings/currency";
import Userable from "../../mixins/userable";
import Suppliers from "../../mixins/inventory/supplier";
import fileSaver from "file-saver";
import xlsx from "xlsx";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  loading: false,
  name: "ReportsByItem",
  mixins: [Currency, Userable, AllSuppliers],
  data: () => ({
    headers: [
      { text: "Item", value: "name", available: true, disabled: true },
      { text: "SKU", value: "sku", available: false },
      { text: "Category", value: "category", available: true },
      { text: "Items sold", value: "items_sold", available: true },
      { text: "Gross sales", value: "gross_sales", available: false },
      { text: "Items refunded", value: "items_refunded", available: false },
      { text: "Refunds", value: "refunds", available: false },
      { text: "Discounts", value: "discounts", available: false },
      { text: "Net sales", value: "net_sales", available: true },
      { text: "Cost of goods", value: "cost_of_goods", available: true },
      { text: "Gross profit", value: "gross_profit", available: true },
      { text: "Taxes", value: "taxes", available: false },
    ],
    data: [],
    params: {},
    dovnExcel: [],
    excel_name: "Items",
    dialog: false,
    page: 1,
    numPages: 1,
    data_loading: false,
    search_field: false,
    search_text: false,
    search: "",
    current_currency: 1,
    access: null,
    wait: true,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  methods: {
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      const current_currency = this.current_currency;
      this.params = params;
      this.data_loading = true;
      let start_date = new Date(params.start_date).getTime();
      let end_date = new Date(params.end_date).getTime();
      this.page = params.page ? params.page : this.page;
      const items = this.$communicator.then(
        this,
        await this.$communicator("sales_by_item_below", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params?.custom,
            start: params?.start?.time,
            end: params?.end?.time,
            search: this.search,
            services: params?.service !== "" ? [params?.service] : [],
            employees:
              params?.employee?._id !== "" ? [params?.employee?._id] : [],
            category: params?.category,
            supplier: this.supplier ? this.supplier?._id : "",
            // supplier:params.supplier?._id !== "" ? params.supplier?._id : this.$store.state.supplier_id_for_item
          },
        })
      );
      this.max_total = items.total;
      for (let i = 0; i < items.data.length; i++) {
        items.data[i].items_sold =
          Math.round(items.data[i].items_sold * 100) / 100;
        items.data[i].cost_of_goods = (
          Math.round(items.data[i].cost_of_goods * current_currency) /
          current_currency
        ).toLocaleString();
        items.data[i].discounts = (
          Math.round(items.data[i].discounts * current_currency) /
          current_currency
        ).toLocaleString();
        items.data[i].gross_profit = (
          Math.round(items.data[i].gross_profit * current_currency) /
          current_currency
        ).toLocaleString();
        items.data[i].gross_sales = (
          Math.round(items.data[i].gross_sales * current_currency) /
          current_currency
        ).toLocaleString();
        items.data[i].net_sales = (
          Math.round(items.data[i].net_sales * current_currency) /
          current_currency
        ).toLocaleString();
        items.data[i].refunds = (
          Math.round(items.data[i].refunds * current_currency) /
          current_currency
        ).toLocaleString();
        items.data[i].taxes = Math.round(items.data[i].taxes).toLocaleString();
      }
      this.data = items?.data;
      this.data_loading = false;
      const respage = Math.ceil(items?.total / 10);
      this.numPages = respage ? respage : 1;
      this.page = respage ? this.page : 1;
    },

    async downloadResult() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const limit = 500;
      let all_data = [];
      const current_currency = this.current_currency;
      let start_date = new Date(this.params.start_date).getTime();
      let end_date = new Date(this.params.end_date).getTime();
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const items = this.$communicator.then(
          this,
          await this.$communicator("sales_by_item_below", {
            arguments: [start_date, end_date, limit, page],
            params: {
              custom: this.params?.custom,
              start: 1,
              end: 12,
              search: this.search,
              services:
                this.params?.service !== "" ? [this.params?.service] : [],
              employees:
                this.params?.employee?._id !== ""
                  ? [this.params?.employee?._id]
                  : [],
              category: this.params?.category,
              // supplier: this.$store.state.supplier_id_for_item
              supplier: this.supplier ? this.supplier?._id : "",
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...items?.data);
      }
      this.proccesDialog = false;

      const result = await all_data.map((itm) => ({
        sku: itm.sku,
        barcode: itm?.barcode?.reduce(function (currentSum, currentNumber) {
          return currentSum + currentNumber + ", ";
        }, ""),
        name: itm.name,
        category: itm.category,
        items_sold: Math.round(itm.items_sold * 100) / 100,
        gross_sales:
          Math.round(itm.gross_sales * current_currency) / current_currency,
        refunds: Math.round(itm.refunds * current_currency) / current_currency,
        net_sales:
          Math.round(itm.net_sales * current_currency) / current_currency,
        cost_of_goods:
          Math.round(itm.cost_of_goods * current_currency) / current_currency,
        gross_profit:
          Math.round(itm.gross_profit * current_currency) / current_currency,
      }));
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Items.xlsx");
    },
  },
  mounted() {
    this.get_currency();
    this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    this.headers = [
      { text: this.$t(`item`), value: "name", available: true, disabled: true },
      { text: this.$t(`sku`), value: "sku", available: false },
      { text: this.$t(`barcode`), value: "barcode", available: false },
      { text: this.$t(`category`), value: "category", available: true },
      { text: this.$t(`items_sold`), value: "items_sold", available: true },
      { text: this.$t(`gross_sales`), value: "gross_sales", available: false },
      {
        text: this.$t(`items_refunded`),
        value: "items_refunded",
        available: false,
      },
      { text: this.$t(`refunds`), value: "refunds", available: false },
      { text: this.$t(`discounts`), value: "discounts", available: false },
      { text: this.$t(`net_sales`), value: "net_sales", available: true },
      {
        text: this.$t(`cost_of_goods`),
        value: "cost_of_goods",
        available: true,
      },
      { text: this.$t(`gross_profit`), value: "gross_profit", available: true },
      { text: this.$t(`taxes`), value: "taxes", available: false },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
    this.supplier = this.$store.state.supplier1;
    if (this.supplier && !this.supplier.supplier_name) {
      this.supplier.supplier_name = this.$t("all_suppliers");
    }
  },
  watch: {
    deep: true,
    handler() {
      this.update();
    },
    supplier() {
      this.update(this.params);
    },
  },
  destroyed() {
    this.$store.state.supplier_id_for_item = "";
  },
};
</script>
